// extracted by mini-css-extract-plugin
module.exports = {"container":"container-1Ba8a","label":"label-2Y1Dj"};